import { INCOMPLETE_TIME_WINDOW_SUFFIX } from '@modules/charts/components/LineChartWrapper/helpers/getPropertyNameForIncompleteTimeWindow';
import { isIncompleteTimeWindowProperty } from '@modules/charts/components/LineChartWrapper/helpers/isIncompleteTimeWindowProperty';

export const getDisplayNameForIncompleteTimeWindow = (dataKey: string) => {
  const displayName = dataKey.split('.value')[0];
  if (isIncompleteTimeWindowProperty(dataKey)) {
    return displayName.split(INCOMPLETE_TIME_WINDOW_SUFFIX)[0];
  }
  return displayName;
};
